import comp from "./SuggestionLibrary";
export default comp;
